import React from 'react';
import { Footer as FooterComponent, IFooterProps } from '../Footer';
import { TFunction, useI18next } from 'gatsby-plugin-react-i18next';
import { useConst } from '../../hooks/useConst';
import { IFooterLinkProps } from '../Footer/FooterLink';

const getLink = (t: TFunction, key: string): IFooterLinkProps => ({
    text: t(`${ key }.label`),
    href: t(`${ key }.href`),
});

export const Footer: React.FunctionComponent = () => {
    const { t } = useI18next('common');

    const menus = useConst<IFooterProps['menus']>(() => [
        {
            title: t('common:footer.menus.engagements.title'),
            links: [
                getLink(t, 'common:footer.menus.engagements.iiap'),
                getLink(t, 'common:footer.menus.engagements.pdf'),
            ],
        }, {
            title: t('common:footer.menus.trustAndSecurity.title'),
            links: [
                getLink(t, 'common:footer.menus.trustAndSecurity.privacy'),
                getLink(t, 'common:footer.menus.trustAndSecurity.license'),
            ],
        }, {
            title: t('common:footer.menus.products.title'),
            links: [ 'axesWord', 'axesSlide', 'axesPdf', 'axesService', 'axesTraining', 'axesSense', 'axesFlip' ].map(
                product => getLink(t, `common:footer.menus.products.${ product }`)
            ),
        }, {
            title: t('common:footer.menus.aboutUs.title'),
            links: [
                getLink(t, 'common:footer.menus.aboutUs.axes4'),
                getLink(t, 'common:footer.menus.aboutUs.join'),
                getLink(t, 'common:footer.menus.aboutUs.events'),
                getLink(t, 'common:footer.menus.aboutUs.partners'),
                getLink(t, 'common:footer.menus.aboutUs.contact'),
            ],
        },
    ]);

    const socialMedia = useConst<IFooterProps['socialMediaMenu']>(() => ({
        title: t('common:footer.socialMedia.title'),
        links: ([ 'twitter', 'linkedin', 'xing' ] as const).map(service => ({
            service,
            label: t(`common:footer.socialMedia.${ service }.label`),
            href: t(`common:footer.socialMedia.${ service }.href`),
        })),
    }));

    const legalLinks = useConst<IFooterProps['legalLinks']>(() => ({
        title: t('common:footer.legal.title'),
        items: [
            getLink(t, 'common:footer.legal.impressum'),
        ],
    }));

    return (
        <FooterComponent
            menus={menus}
            socialMediaMenu={socialMedia}
            legalLinks={legalLinks}
        />
    );
};
